import { API_ENDPOINTS } from '@tsgecart/config';
import { storefrontApiFetch } from '../../../../lib/api/storefront-client.js';
import type { ServiceabilityResult } from '../types/delivery.js';

export interface FetchOptions {
  signal?: AbortSignal;
}

/**
 * `GET /delivery/serviceability/:pincode` -- one of the few genuinely
 * public (no-auth) commerce routes, see
 * `apps/worker/src/routes/v1/commerce/delivery.ts`. No token passed,
 * matching the storefront catalog reads' pattern.
 */
export async function fetchServiceability(pincode: string, options: FetchOptions = {}): Promise<ServiceabilityResult> {
  return storefrontApiFetch<ServiceabilityResult>(`${API_ENDPOINTS.delivery}/serviceability/${pincode}`, options);
}
